import {gql} from "graphql-request";

// Hasura actions handled by dxn-mcp (MCP_BASE_URL/oauth/portal/...)

export const mcpAuthorizationRequestQuery = gql`
  query McpAuthorizationRequest($request: String!) {
    mcp_authorization_request(request: $request) {
      client_name
      redirect_uri
      resource
      scope
      expires_at
    }
  }
`;

export const mcpAuthorizationDecisionMutation = gql`
  mutation McpAuthorizationDecision($request: String!, $approve: Boolean!) {
    mcp_authorization_decision(request: $request, approve: $approve) {
      redirect_to
    }
  }
`;
